import $ from "jquery"
import DropdownTemplateView from "../../DropdownTemplateView"
import SimpleTooltip from '../../SimpleTooltip'
import messageResource from '../../messageResource'

export default class CustomerStatusMenu extends DropdownTemplateView {
    templateHtml() {
        return "<div class='dropdownContainer customerStatusMenu'>" +
               "  <div class='activeStatus'>" +
               "    <div class='cover'></div>" +
               "    <div class='item activeContainer'>" +
               "        <div class='active'><%-active%></div>" +
               "    </div>" +
               "  </div>" +
               "  <div class='item archivedContainer'>" +
               "    <div class='archived'><%-archived%></div>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        var self = this;
        this.$activeStatus = this.$el.find('.activeStatus')
        this.findAndBindClick(".activeContainer", function(e) {
            stopEventPropagation(e);
            self._itemClick(e, true);
        });
        this.findAndBindClick(".archivedContainer", function(e) {
            stopEventPropagation(e);
            self._itemClick(e, false);
        });

        const inactiveOpenStatusTooltip = this.inactiveOpenStatusTooltip()
        inactiveOpenStatusTooltip.subscribeToMouseEvents(this.$activeStatus)
    }

    update() {
        this.$el.toggleClass("active", this.active);
        this.$el.toggleClass("archived", !this.active);
        this.$activeStatus.toggleClass('inactive', this.inactiveOpenStatus)
    }

    showAt($element, positionParams, callback) {
        super.showAt($element, positionParams);
        this.update();
        this.callback = callback;
    }

    messageKeys() {
        return {
            active: "customer.edit.status.active",
            archived: "customer.edit.status.archived"
        }
    }

    onHide() {
        super.onHide();
        this.callback(this.active);
    }

    isActive() {
        return this.active;
    }

    setActive(active) {
        this.active = active;
    }

    _itemClick(e, active) {
        this.active = active;
        this.hide();
    }

    mouseDownTargetElement() {
        return $('body')
    }

    setInactiveOpenStatus(inactiveOpenStatus) {
        this.inactiveOpenStatus = inactiveOpenStatus
        this.inactiveOpenStatusTooltip().setEnabled(inactiveOpenStatus)
    }

    inactiveOpenStatusTooltip() {
        if (!CustomerStatusMenu.tooltip) {
            CustomerStatusMenu.tooltip = new SimpleTooltip({
                text: messageResource.getMessage('task.list.tooltip.project.inactive_open_statuses'),
                extraClass: 'workflowStatusList_inactiveOpenStatusesTooltip',
            }).init($('body'))
        }
        return CustomerStatusMenu.tooltip
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/task/CustomerStatusMenu.js